// Dartmouth's undergraduate majors (#2652). Read on 2026-10-01 from
// Dartmouth Admissions' Majors & Minors list (admissions.dartmouth.edu/
// academics/majors-minors), which links each major to the Areas of Study
// page that covers it; the groups here are those six pages. Left out: the
// entries the list marks [m] (minor only) and * (major modification only,
// Medieval and Renaissance Studies). Degree names are Dartmouth's own from
// its Degree Finder (home.dartmouth.edu/degrees), which lists each major as
// a Bachelor of Arts and Engineering Sciences also as a Bachelor of
// Engineering; majors the Degree Finder does not list under the same name
// (Middle Eastern Studies, Native American and Indigenous Studies, East
// European, Eurasian, and Russian Studies, Portuguese (Lusophone Studies),
// Environmental Earth Sciences, Mathematical Data Science) carry no degree.
// The KB's majors list was the starting point; the school's list wins.
const majors = {
    "slug": "dartmouth-college",
    "read": "2026-10-01",
    "intro": "Every major on Dartmouth Admissions' official Majors & Minors list, grouped by the area of study it belongs to, with the degree where Dartmouth's Degree Finder names it. Minors, major modifications and graduate programs are left out.",
    "groups": [
        {
            "name": "Interdisciplinary",
            "source": {
                "label": "Dartmouth Admissions, Areas of Study: Interdisciplinary",
                "url": "https://admissions.dartmouth.edu/academics/areas-of-study/interdisciplinary"
            },
            "majors": [
                {
                    "name": "African and African American Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Latin American, Latino, and Caribbean Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Linguistics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Middle Eastern Studies",
                    "degree": null
                },
                {
                    "name": "Native American and Indigenous Studies",
                    "degree": null
                },
                {
                    "name": "Quantitative Social Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Humanities",
            "source": {
                "label": "Dartmouth Admissions, Areas of Study: Humanities",
                "url": "https://admissions.dartmouth.edu/academics/areas-of-study/humanities"
            },
            "majors": [
                {
                    "name": "Ancient History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Asian Societies, Cultures, and Languages",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Classical Archaeology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Classical Languages and Literatures",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Classical Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "East European, Eurasian, and Russian Studies",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "French",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "French Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "German Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Italian",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Italian Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Portuguese (Lusophone Studies)",
                    "degree": null
                },
                {
                    "name": "Religion",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Romance Languages",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Romance Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Spanish (Hispanic Studies)",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Social Sciences",
            "source": {
                "label": "Dartmouth Admissions, Areas of Study: Social Sciences",
                "url": "https://admissions.dartmouth.edu/academics/areas-of-study/social-sciences"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Geography",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Government",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Neuroscience",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Art and Performing Arts",
            "source": {
                "label": "Dartmouth Admissions, Areas of Study: Art and Performing Arts",
                "url": "https://admissions.dartmouth.edu/academics/areas-of-study/art-performing-arts"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Studio Art",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Theater",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Physical and Life Sciences",
            "source": {
                "label": "Dartmouth Admissions, Areas of Study: Physical and Life Sciences",
                "url": "https://admissions.dartmouth.edu/academics/areas-of-study/physical-life-sciences"
            },
            "majors": [
                {
                    "name": "Astronomy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biological Chemistry",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Biophysical Chemistry",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Earth Sciences",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Earth Sciences",
                    "degree": null
                },
                {
                    "name": "Mathematical Data Science",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "Engineering",
            "source": {
                "label": "Dartmouth Admissions, Areas of Study: Engineering",
                "url": "https://admissions.dartmouth.edu/academics/areas-of-study/engineering"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering Sciences",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Engineering Sciences",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Engineering Sciences",
                    "degree": "Bachelor of Engineering"
                }
            ]
        }
    ]
};

export default majors;
